// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"10663800","95":"c0940ca7","197":"c9eb5691","275":"941645d9","379":"ea74a1da","428":"973794c1","494":"726033c0","871":"8265fbcf","933":"6702d9aa"}[chunkId] + ".chunk.js";
};